module.exports = __webpack_public_path__ + "static/media/01.1992eca3.jpg";